import { TextBody2, TextLabel } from "common/components";
import {
  TableWrapper,
  TableRow,
  TableHeaderCell,
  TableCell,
} from "common/components/Table/table";
import {
  PaymentChannel,
  PaymentMethod,
  PaymentStatus,
} from "common/enum/PaymentTypes";
import { REQUEST_METHOD } from "common/enum/RequestMethod";
import { useApiRequest } from "common/utils/api";
import { DataLoadingLayout } from "common/utils/DataLoadingLayout";

export const SalesDetailModalBody = ({ paymentId }) => {
  const { data, loading } = useApiRequest({
    method: REQUEST_METHOD.GET,
    url: `/api/v2.0/payment/${paymentId}`,
    queryParameter: { clubId: sessionStorage.getItem("clubId") },
  });

  const filterData = () => {
    const targetData = data?.payment;
    if (!targetData) return [];
    return [
      { title: "Payment ID", value: targetData.paymentTrxId },
      {
        title: "Date",
        value: targetData.paymentAt?.replace("T", " ").slice(0, 19),
      },
      {
        title: "Status",
        value: (
          <TextLabel color={PaymentStatus[targetData.status]?.color}>
            {PaymentStatus[targetData.status]?.text}
          </TextLabel>
        ),
      },
      {
        title: "Discount amount",
        value: `${targetData.currency} ${Number(targetData.discountAmount).toFixed(2)}`,
      },
      {
        title: "Amount paid",
        value: `${targetData.currency} ${Number(targetData.actualAmount).toFixed(2)}`,
      },
      {
        title: "Items",
        value: targetData.items?.map((i) => (
          <div style={{ margin: "0.5rem 0" }} key={i.id}>
            {i.itemName} * {i.quantity}
          </div>
        )),
      },
      {
        title: "Payment method",
        value: PaymentMethod[targetData.paymentMethod],
      },
      {
        title: "Payment channel",
        value: PaymentChannel[targetData.paymentPath],
      },
      {
        title: "Player information",
        subTitle: "(Name, QR ID with date)",
        value: targetData.payerName,
      },
      {
        title: "Note",
        subTitle: "(Reason for future refund)",
        value: targetData.memo ?? "-",
      },
    ];
  };

  return (
    <DataLoadingLayout loading={loading}>
      <TableWrapper style={{ minWidth: "40rem" }}>
        {filterData().map((row) => (
          <TableRow>
            <TableHeaderCell width={"30%"}>
              {row.title}
              {row.subTitle && <TextBody2>{row.subTitle}</TextBody2>}
            </TableHeaderCell>
            <TableCell> {row.value}</TableCell>
          </TableRow>
        ))}
      </TableWrapper>
    </DataLoadingLayout>
  );
};
